import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import clsx from 'clsx';
import { AnyCriteria } from '../types/AlertConfiguration';
import { CriteriaError, ValidationError } from './AlertCriteria';
import { BlockAnd } from './BlockAnd';
import styles from './BlockContent.module.less';

type Props = {
  criteriaGroups: AnyCriteria[][];
  criteriaErrors: (CriteriaError | null)[][];
  handleAddOr: (i: number) => void;
  handleRemoveOr: (iAnd: number, iOr: number) => void;
  handleCriteriaChange: (iAnd: number, iOr: number, criteria: AnyCriteria, error: ValidationError | null) => void;
  addAnd: () => void;
  onCriteriaPaste: (indexAnd: number, indexOr: number) => void;
  onCriteriaCopy: (criteria: AnyCriteria) => void;
  isCopiedCriteria: boolean;
  setCopiedError: (error: CriteriaError | null) => void;
};

export const BlockContent: React.FC<Props> = ({
  criteriaGroups,
  criteriaErrors,
  handleAddOr,
  handleRemoveOr,
  handleCriteriaChange,
  addAnd,
  onCriteriaPaste,
  onCriteriaCopy,
  isCopiedCriteria,
  setCopiedError,
}) => {
  return (
    <div className={styles.blockContent}>
      {/*TODO: Alert explanation will be temporarily hide, in the future we will finish and show again*/}
      {/*<div className={clsx(styles.blockExplain, 'box')}>*/}
      {/*  <h3 className={styles.label}>Alert Explanation: Lorem ipsum dolor sit amet, consectetur adipiscing elit...</h3>*/}
      {/*</div>*/}

      {criteriaGroups.length === 0 && (
        <div className={clsx(styles.blockEmptyCriteria, 'box')}>
          <h4>This alert is not currently defined. Please add criteria to create an alert.</h4>
          <div className={styles.xCenter}>
            <Button type="primary" className={styles.buttonAddCriteria} onClick={addAnd}>
              <FontAwesomeIcon icon={['fal', 'plus']} size="xs" />
              Add Criteria
            </Button>
          </div>
        </div>
      )}
      {criteriaGroups.map((group, i) => (
        <BlockAnd
          key={i}
          group={group}
          errors={criteriaErrors[i]}
          indexAnd={i}
          onAddOr={() => handleAddOr(i)}
          onRemoveOr={handleRemoveOr}
          onCriteriaChange={(iOr, criteria, error) => handleCriteriaChange(i, iOr, criteria, error)}
          onCriteriaPaste={onCriteriaPaste}
          onCriteriaCopy={onCriteriaCopy}
          isCopiedCriteria={isCopiedCriteria}
          setCopiedError={setCopiedError}
        />
      ))}
      {criteriaGroups[0]?.length && (
        <Button type="primary" disabled={false} className={styles.buttonAnd} onClick={addAnd}>
          <FontAwesomeIcon icon={['fal', 'plus']} size="xs" />
          AND
        </Button>
      )}
    </div>
  );
};
